<alaris-card>
	<div class="table-management">
		<div class="left">
			<span class="total">{{ totalTitle | translate }}: {{ total }}</span>
			<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-filter-vertical"></alaris-icon>
				{{ enableButtons.filters.title | translate }}
				@if (state.isFiltersApplied) {
				<div class="indicator"></div>
				}
			</button>
		</div>
		<div class="right">
			<button (click)="refresh()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'actions.refresh_page' | translate }}
			</button>
			<button
				(click)="export()"
				[disabled]="!!(exporting$ | async)"
				alaris-button
				bType="outline"
				size="lg"
				[disabled]="!this.user.allowed(['simulations.edit'])">
				@if (exporting$ | async) {
				    <alaris-spinner></alaris-spinner>
				} @else {
				    <alaris-icon name="icon-export"></alaris-icon>
				}
				{{ 'gl.export' | translate }}
			</button>
			<button
				(click)="createNewTask()"
				alaris-button
				bType="primary" size="lg"
				[disabled]="!this.user.allowed(['simulations.edit'])">
				<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
				{{ 'simulation.add' | translate }}
			</button>
		</div>
	</div>
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		@if (tRows.length === 0 && !state.isFiltersApplied) {
		<app-empty-table
			type="si-task"
			[disabled]="!this.user.allowed(['simulations.edit'])"
			(newSiTask)="createNewTask()"></app-empty-table>
		} @else {
			<alaris-table
					(filtersChange)="_applyFilter($event)"
					(sortingChange)="_applySorting($event)"
					[filters]="state.filters()"
					[dblClickRowAction]="dblClickRowAction.bind(this)"
					[dropDownRowActions]="dropDownRowActions"
					[rowActions]="rowActions"
					[tHeaders]="tHeaders()"
					[tRows]="tRows"
					[resizable]="resizable"
					[templates]="{author, createdAt, dippingRule, id, status}"
					alarisOverflowFader></alaris-table>
		}
	</div>
	<div class="footer">
		<alaris-pagination
			(page)="_pageChange($event)"
			[activePage]="activePage"
			[class.without-table-bar]="selection !== null && selection.length === 0"
			[hidden]="total === 0"
			[pageSizeOptions]="pageSizeOptions"
			[pageSize]="pageSize"
			[total]="total"
			class="pagination"></alaris-pagination>
	</div>
</alaris-card>

<ng-template #id [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="id">
		<alaris-icon name="icon-package" class="source-icon"></alaris-icon>
		<div class="task-info">
			<div class="task-id">SI-{{ data.id }}</div>
			<div class="meta">
				@if(data.productName){
					{{ data.productName }}
				}
				@if(data.prefix){
					{{ data.prefix }}
				}
				@if(data.senderId){
					{{ data.senderId }}
				}
			</div>
		</div>
	</div>
</ng-template>

<ng-template #author [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	@let firstName = data.author?.details?.firstName; @let lastName = data.author?.details?.lastName; @if (firstName &&
	lastName) {
	<span>{{ firstName }}&nbsp;{{ lastName }}</span>
	} @else {
	<span>
		{{ data.author?.login }}
	</span>
	}
</ng-template>

<ng-template #status [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<app-simulation-status [task]="data"></app-simulation-status>
</ng-template>

<ng-template #createdAt let-data="data" [alarisCellCtx]="tRows[0]" let-key="key">
	<span>{{ formatDate(data.createdAt) }}</span>
</ng-template>

<ng-template #dippingRule let-data="data" [alarisCellCtx]="tRows[0]" let-key="key">
	@if ( data.dippingRule ) {
		<span>{{ data.dippingRule }}</span>
	} @else {
		<span>{{ 'gl.errors.undefined' | translate }}</span>
	}
</ng-template>
